module.exports = __webpack_public_path__ + "static/media/Logo_name.cd2efb8d.jpg";